/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ since: NonNullable<unknown> }} Inbound_Waiting_On_GoodsInputs */

const en_inbound_waiting_on_goods = /** @type {(inputs: Inbound_Waiting_On_GoodsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Waiting for the goods · since ${i?.since}`)
};

/**
* | output |
* | --- |
* | "Waiting for the goods · since {since}" |
*
* @param {Inbound_Waiting_On_GoodsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_waiting_on_goods = /** @type {((inputs: Inbound_Waiting_On_GoodsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Waiting_On_GoodsInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_waiting_on_goods(inputs)
});